import React from "react";
import DepartmentHome from "../components/DepartmentHome.jsx";

const items = [
  ["New Hire Packet", "/portal/onboarding", "Fill out and e-sign your onboarding forms"],
  ["My Schedule", "/portal/schedule", "See your upcoming visits"],
  ["Mobile Portal", "/portal/mobile", "Phone-friendly view of your day"],
  ["EVV / Clock In", "/portal/evv", "Clock in and out of your visits"],
  ["Messages", "/portal/communications", "Messages from the office and families"],
  ["Compliance", "/portal/compliance", "Your certifications, tests and due dates"],
  ["Training", "/portal/training", "Take your assigned courses"],
  ["Mileage", "/portal/mileage", "Log miles driven for reimbursement"],
  ["Timesheets", "/portal/timesheets", "Review and submit your hours"],
];

const icons = {
  "New Hire Packet": "🖊️",
  "My Schedule": "📅",
  "Mobile Portal": "📱",
  "EVV / Clock In": "📍",
  "Messages": "💬",
  "Compliance": "🛡️",
  "Training": "🎓",
  "Mileage": "🚗",
  "Timesheets": "🕒",
};

export default function PortalHome() {
  return (
    <DepartmentHome
      title="My Caregiver Portal"
      description="Your schedule, visits, training, compliance, and paperwork."
      items={items}
      icons={icons}
    />
  );
}
